
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
:host{display:block}hr{border:1px;border-top:1px solid var(--black-450);height:0;margin:0;margin-block-end:1rem;margin-block-end:var(--hr--margin-block-end,1rem);margin-block-start:1rem;margin-block-start:var(--hr--margin-block-start,1rem)}`;